<script setup lang="ts">
import { computed } from 'vue'
import GwBtnGroup, { type GwBtnGroupItem } from '@/components/lib/GwBtnGroup/GwBtnGroup.vue'
import { t } from '@/locales/i18n'
import { getScreenUtils } from '@/components/lib/GwUtils/utils_screen'

export interface AnalyzerReportSwitchProps {
  value?: string
  tstPrefix?: string
}

const props = defineProps<AnalyzerReportSwitchProps>()

const { mobile } = getScreenUtils()

const options = computed(
  () =>
    [
      {
        id: 'TABLE',
        text: mobile.value ? '' : t('common.hands'),
        btnProps: { icon: 'mdi-table' },
      },
      {
        id: 'STATS',
        text: mobile.value ? '' : t('common.stats'),
        btnProps: { icon: 'mdi-calculator-variant' },
      },
    ] as Array<GwBtnGroupItem>,
)

const emit = defineEmits(['click'])

const handleClick = (e: Event, item: GwBtnGroupItem) => {
  if (props.value === item.id) return
  emit('click', e, item.id)
}
</script>
<template>
  <GwBtnGroup
    isSingle
    :options="options"
    :value="value"
    :tstPrefix
    boxVariant="box_row_dark2_pad2"
    direction="horizontal"
    :btnProps="{
      variant: 'btn_text_grey_white_icon_grey_primary-v2',
    }"
    style="height: 2.125rem"
    @click="handleClick"
  >
    <template #default="{ item }">
      {{ item.text }}
    </template>
  </GwBtnGroup>
</template>
